import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=55ca7978"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=55ca7978&prod&lang=css"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&id=55ca7978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports